import {
    RequestService,
    RequestServiceResponse,
} from '@tcc-online/request-service';
import { StorageService } from './StorageService';
import IIntegrationParams from '../../types/integration/IIntegrationParams';
import IIntegration from '../../types/integration/IIntegration';

const ENDPOINT = '/integrations';
const PARAMS_KEY = 'INTEGRATION_QUERY_PARAMS';

const IntegrationService = {
    getIntegration,
    enableIntegration,
    setParams,
    removeParams,
    getParams,
};

async function getIntegration(
    payload: IIntegrationParams,
): Promise<RequestServiceResponse<IIntegration>> {
    const { integrator, companyId } = payload;

    return await RequestService.get<IIntegration>(
        `${ENDPOINT}/${integrator}/${companyId}`,
    );
}

async function enableIntegration(
    payload: IIntegrationParams,
): Promise<RequestServiceResponse<unknown>> {
    const { integrator, companyId } = payload;

    return await RequestService.patch(
        `${ENDPOINT}/${integrator}/${companyId}`,
        { enabled: true },
    );
}

function setParams(params: string): void {
    StorageService.setSession(PARAMS_KEY, params);
}

function removeParams(): void {
    StorageService.deleteSession(PARAMS_KEY);
}

function getParams(): string | undefined {
    return StorageService.getSession(PARAMS_KEY, undefined);
}

export default IntegrationService;
